import React from 'react';
import styles from './Button.module.scss';

export default function Button(props) {
    return <button type="button" className={props.outline ? styles.outlineButton : styles.primaryButton} onClick={props.onClick}>{props.text}</button>
}